import { useRef } from "react";
import {
  FlightConfigProvider,
  FlightFareSourcesProvider,
} from "@b2bportal/core-flights";
import { usePackageFlightFaresSource } from "../../hooks/usePackageFlightFaresSource";
import { flightsAppConfig } from "@/pages/Flights/config";
import { sortFaresWithExtrasRbc } from "@/utilities/flights/sortFaresWithExtras";

export const PackageFlightsWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const flightFaresSourceHooks = useRef([usePackageFlightFaresSource]);

  return (
    <FlightConfigProvider context={flightsAppConfig}>
      <FlightFareSourcesProvider
        hooks={flightFaresSourceHooks.current}
        transform={sortFaresWithExtrasRbc}
      >
        {children}
      </FlightFareSourcesProvider>
    </FlightConfigProvider>
  );
};
